<template>
	<div>

		<div v-if="showContenedor">

			<!-- <div v-if="error" class="frm-error">{{ error_message }}</div> -->

			<div class="contenedor">

				<div class="row">
					<div class="col-sm-6">
						<h3><router-link :to="datos.enlace">{{ datos.titulo }} <span class="c-quantity">( {{ quantity }} )</span></router-link></h3>	
					</div>
					<div class="col-sm-6 right">
						<router-link :to="datos.enlace" class="more-link">{{ $t('Ver') + ' ' + datos.titulo }}</router-link>
					</div>
				</div>

				<!-- <pre>
					{{ datosContenedor }}
				</pre> -->

				<div class="row" v-if="loading">
		      <div class="col-md-12 height center">
		        <div class="loading c-mt-loading"><img src="@/assets/img/loading.gif" alt=""></div>
		      </div>
		    </div>
				
				<div v-else class="row height">
					<div class="col-md-12">
						<div v-if=" datosContenedor.length > 0 " class="wrapper-owl-carousel">
							<div class="owl-carousel owl-theme">
								<div v-for="data in datosContenedor" :key="data.id">
									<ficha-basica :datos="data" :key="data.id"
										:type.sync="modalType"
										:productID.sync="modalProductID"
										:show.sync="showModalFichaExtendida"
										:contenedor.sync="contenedor">
									</ficha-basica>
								</div>
								<div>
									<div class="article-wrapper">
										<router-link :to="datos.enlace" class="more-items">
											{{ $t('Ver todos') }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
						<div v-else class="text-center">
							<div class="c-mt-no-article">{{ $t('No hay artículos que mostrar!') }}</div>
						</div>
					</div>
				</div>

				      <!-- <ficha-basica v-for="data in datosContenedor" :datos="data" :key="data.id"
				        :type.sync="modalType"
				        :productID.sync="modalProductID"
				        :show.sync="showModalFichaExtendida">
				      </ficha-basica> -->

	      	<!-- <div v-if="error" class="frm-error">{{ error_message }}</div> -->

			</div>

			<modal-ficha-extendida 
	      :show.sync="showModalFichaExtendida"
	      :type="modalType"
	      :productID="modalProductID"
	      :contenedor="contenedor">
	    </modal-ficha-extendida>

		</div>
	</div>
</template>

<i18n>
{
  "es": {
    "Ver": "Ver",
    "Ver todos": "Ver todos",
		"No hay artículos que mostrar!": "No hay artículos que mostrar!"
  },
  "en": {
    
  },
  "ca": {
    "Ver": "Veure",
    "Ver todos": "Veure tots",
		"No hay artículos que mostrar!": "No ho hi ha articles per mostrar!"
  }
}
</i18n>

<script>
	import axios from 'axios';
	import FichaBasica from './FichaBasica.vue';
	import ModalFichaExtendida from './ModalFichaExtendida.vue';
	import { mapGetters } from 'vuex';

	export default {
		components: { FichaBasica, ModalFichaExtendida },
	  props:['datos'],
		data: () => {
			return{
				showModalFichaExtendida: false,
        modalType: "",
        modalProductID: 0,
        contenedor: '',
        loading: false,
        error: false,
        error_message: '',
        showContenedor: true,
        rawData: []
			}
		},
		created(){
			this.cargarDatosContenedor();
			//this.datosContenedor = this.datos.data.resultados
			//this.startOwl();
		},
		mounted(){
			//console.log(this.datos.data.resultados)
			//this.startOwl();
		},
		updated(){
			this.startOwl();
		},
		computed: {
      ...mapGetters(['getLocale', 'getApiUrl', 'getMaxElementosContenedor', 'getSelectionBus']),
      datosContenedor: function(){ return (this.rawData != '') ? this.rawData.data.data.resultados : '' },
			quantity: function(){ return this.datosContenedor ? this.rawData.data.data.num_resultados : 0 }
    },
		methods:{
			cargarDatosContenedor(){
				this.showLoading();
				axios.get(this.getApiUrl + this.getLocale + '/' + this.datos.enlace + '&rpp=' + this.getMaxElementosContenedor )
        .then( (respuesta) =>{
          this.rawData = respuesta;
          this.hideLoading();
        })
        .catch( (error) =>{ 
					//console.log(error.response)
          this.error_message = error.response.data.status + ' ' + error.response.data.msg;
          this.error = true;
          this.hideLoading()		
					
					//console.log(error.response.data.status)

          if( error.response.data.status == 404 || error.response.data.status == 400 ) { 
						this.showContenedor = false; 
						//console.log(this.showContenedor)
					}
        });           
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      startOwl(){
      	var owl = jQuery('.owl-carousel');
				owl.owlCarousel({
			    margin: -10,
			    loop: false,
			    autoWidth:true,
			    nav: true,
			    navText:['<i class="fa fa-angle-left">', '<i class="fa fa-angle-right">'],
			    slideBy: 5,
					dots: false,   
				});
				/*owl.on('mousewheel', '.owl-stage', function (e) {
			    if (e.deltaY>0) {
			        owl.trigger('next.owl');
			    } else {
			        owl.trigger('prev.owl');
			    }
			    e.preventDefault();
				});*/
      }
		},
		watch:{
			/* $route: function() {
				this.rawData = '';
	      this.cargarDatosContenedor();
	    }, */
	    getSelectionBus: function(){
        //console.log(this.datosContenedor === Object)
        //console.log(JSON.stringify(this.getSelectionBus))
        if( !(Object.keys(this.getSelectionBus).length === 0) && !(this.getSelectionBus === Object) ){ 
	        if( !(Object.keys(this.datosContenedor).length === 0) && !(this.datosContenedor === Object) ){
	        	//console.log(this.datosContenedor === Object);
        		//console.log(JSON.stringify(this.getSelectionBus));
	        	let id = this.getSelectionBus.id;
	        	var obj = this.datosContenedor.find(function (obj) { return obj.id === id; });
		        if( obj ){
		        	obj.miseleccion = this.getSelectionBus.miseleccion;
		        	//console.log(JSON.stringify(obj))
		        }
		      }
		    }
      },
      /* datos: function(newValue){
      	this.cargarDatosContenedor();
      },   */
	  }
	}
	
</script>
<style scoped>
	.height{ height: 410px; }
	.c-mt-no-article{ margin-top: 190px; }
	.c-mt-loading{ margin-top: 160px; }
	
  .c-quantity{ 
    display: inline-block; 
    font-weight: 100;
    color: #BBB;
    margin-left: 5px;
  }
</style>